import { NotificationForm } from '../../../../../../notificationForms/sections/notifications/components/NotificationForm'
import { NotificationView } from '../../../../../../notificationForms/sections/notifications/components/NotificationView'

import { TodayNotificationView } from './components/TodayNotificationView'

import { useFormStateController } from '../../hooks/useFormStateController'
import { useTodayNotificationSubmit } from './hooks/useTodayNotificationSubmit'
import { useTodayNotificationToggle } from './hooks/useTodayNotificationToggle'
import { useTodayNotificationValues } from './hooks/useTodayNotificationValues'

import type { FormProps } from '../types'
import { useTexts } from './useTexts'

/**
 * Renders the Today notification form providing all the domain data and apis.
 */
export function TodayNotification(props: FormProps) {
  const { inEditing, setEditingState } = props

  const values = useTodayNotificationValues()

  const { toggleDescription, onToggle } = useTodayNotificationToggle(values)
  const { edit, cancel } = useFormStateController(setEditingState)
  const onSubmit = useTodayNotificationSubmit()

  const texts = useTexts()

  // Render the Form inside a FormRoot component that will expose the FormState API through a React.Context
  if (inEditing) {
    return (
      <NotificationForm
        subtitle={texts.description}
        notification={'today'}
        onSubmit={onSubmit}
        title={texts.title}
        cancel={cancel}
        values={values}
      />
    )
  }

  return (
    <NotificationView
      Form={<TodayNotificationView values={values} />}
      toggleSubtitle={toggleDescription}
      subtitle={texts.description}
      notification={'today'}
      onToggle={onToggle}
      title={texts.title}
      values={values}
      onEdit={edit}
    />
  )
}
